import { Select, SelectProps } from 'antd';
import styled from 'styled-components';

export const BlockTypeSelect = styled(Select)<SelectProps>`
  &&.emp-ant-select {
    .emp-ant-select-selector {
      height: 28px;
      border-radius: 3px;
      border-color: rgba(0, 0, 0, 0.15);
      background-color: rgba(0, 0, 0, 0.04);
      padding: 3px 10px;

      .emp-ant-select-selection-item {
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: -0.12px;
        display: flex;
        align-items: center;
      }
    }
  }
`;

export const BlockRuleRowWrapper = styled.div`
  display: flex;
  padding: 8px 0;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

export const BlockRuleName = styled.span`
  width: 75px;
  color: rgba(0, 0, 0, 0.65);

  line-height: 20px;
  letter-spacing: -0.14px;
`;

export const DeleteButtonWrapper = styled.div`
  display: flex;
  padding: 0 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
